import replaceSearchParam, { Conditions } from './replaceSearchParam';

const LOGGER_REPLACER = '*REDACTED*';

const conditions: Conditions = [
  /**
   * token 이 포함된 param 제거
   * token : 참여자 페이지 접근 시, 접근 토큰 @see https://github.com/modusign/modusign-client/blob/e156f8b0072d94269fc13d96ce98bb8b7bba7d33/app/src/routes/Participant/lib/__test__/getParsedParams.spec.ts#L19
   * authorization_token : 권한 인증을 위한 oAuth 토큰 @see https://github.com/modusign/modusign-client/blob/e156f8b0072d94269fc13d96ce98bb8b7bba7d33/app/src/features/integration/oauth/components/PermissionAuthorization/index.tsx#L26
   */
  (key) => /token/gi.test(key),
  (key) => key === 'at', // 엑세스 토큰
  (key) => key === 'lk', // 계약문서 이메일 접근 시 링크 key
];

const scrubURL = (url: string) => replaceSearchParam(url, conditions, LOGGER_REPLACER);

export default scrubURL;
